<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { useLocaleStore } from '@/stores/locale';
const t = useI18n().t;
const localeStore = useLocaleStore();

</script>
<template>
    <section class="gap">
        <div class="container">
            <div class="heading">
                <img src="../../../assets/img/heading-img.png" alt="img">
                <span>{{ t('Construction Services') }}</span>
                <h2> {{ t('We Offer Comprehensive Construction Services') }}</h2>
            </div>
            <div class="row g-4" :dir="localeStore.locale == 'ar' ? 'rtl' : 'ltr'">
                <div class="col-lg-4 col-md-6">
                    <div class="services-one" style="background-image: url(../../../../../assets/img/bg-lins-img.jpg);">
                        <i class="flaticon-skyline"></i>
                        <p class="fs-2">{{ t('Commercial') }}</p>
                        <p>{{ t('We care about the communities we our communities too') }}. {{ t('we’re designers') }},
                            {{ t('and projects mannagers, innovating of community, creativity') }}</p>
                        <!-- <router-link :to="'/services'"> <i class="fa-solid fa-arrow-right"></i></router-link> -->
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="services-one" style="background-image: url(../../../../../assets/img/bg-lins-img.jpg);">
                        <i class="flaticon-hook"></i>
                        <p class="fs-2">{{ t('Contracting') }} </p>
                        <p>{{ t('We care about the communities we our communities too') }}. {{ t('we’re designers') }},
                            {{ t('and projects mannagers, innovating of community, creativity') }}</p>
                        <!-- <router-link :to="'/services'"> <i class="fa-solid fa-arrow-right"></i></router-link> -->
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="services-one" style="background-image: url(../../../../../assets/img/bg-lins-img.jpg);">
                        <i class="flaticon-villa"></i>
                        <p class="fs-2">{{ t('Residential') }} </p>
                        <p>{{ t('We care about the communities we our communities too') }}. {{ t('we’re designers') }},
                            {{ t('and projects mannagers, innovating of community, creativity') }}</p>
                        <!-- <router-link :to="'/services'"> <i class="fa-solid fa-arrow-right"></i></router-link> -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style lang="scss" scoped></style>